<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'엑셀 업로드 결과'"
      :modal="true"
      :width="'700px'"
      :scrollable="true"
      style="display:none;">
    <template>
      <div class="pop-container">
        <div class="pop-conts">
          <div class="box_flex tab ">
              <li class="txt_c">업로드 항목 : <b>{{ data.totalCnt }}</b></li>
              <li class="txt_c">업로드 성공 : <b class="txt_g">{{ data.uploadSuccessCnt }}</b></li>
              <li class="txt_c mg0"><span class="txt_o">업로드 실패 : {{ data.uploadFailCnt }} </span></li>
            </div>
          <div class="f_r mb10">
            <button v-show="!!data.uploadFailCnt && data.uploadFailCnt>0" type="button" class="mid_btn" @click="failDownload" >
              <span><span class="k-icon k-i-download "></span>실패 목록 다운로드</span>
            </button>
          </div>
          <kendo-grid ref="errorGridRef"
                      style="cursor: pointer;"
                      class="basic_table mt10"
                      :data-source="getErrorDataSource"
                      :columns="errorListColumns"
                      :filterable="false"
                      :sortable="false"
                      :scrollable="true"
                      :pageable-always-visible="false"
                      :reorderable="true"
                      :column-menu="false"
                      :resizable="true"
                      :selectable="'multiple row'"
                      :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }">
          </kendo-grid>
          <div class="k-text-center mgt30 button_area">
            <button type="button" id="buttonCancel" class="large_btn orange" @click="onClickClose">확인</button>
          </div>
        </div>
      </div>
    </template>
  </kendo-window>
</template>

<script>
import $ from 'jquery'
import * as XLSX from "xlsx"
import * as FileSaver from 'file-saver'
import EtnersCommonUtil from "@/common/etners.common.util";
import app from '@/main';

export default {
  name: 'ExcelUploadResultWindow',
  props: {
    data : {
      type : Object,
      required : false,
      default : function (){
        return {}
      }
    },
    file : {
      type : Object,
      required : false,
      default : function (){
        return {}
      }
    },
    sendScn: {
      type: String,
      required : false,
      default : function (){
        return {}
      }
    }
  },
  computed: {
    getErrorDataSource () {
      if (EtnersCommonUtil.isEmpty(this.data)) {
        return []
      }
      const failMsgInfoList = this.data.failMsgInfoList
      let rowNumber = 1
      if (failMsgInfoList === null) {
        return false
      }
      for (let i = 0; i < failMsgInfoList.length; i++) {
        const row = failMsgInfoList[i]
        row.rowNumber = rowNumber++
      }
      return failMsgInfoList
    },
  },
  methods: {
    failDownload () {
      const vm = this

      app.$Progress.plus()
      setTimeout(function (){
        // 최초 엑셀 파일 불러오기
        let workbook = vm.file
        // '발송양식' 시트 가져오기
        const sheetName = vm.getSheetName()
        const worksheet = workbook.Sheets[sheetName]
        // 엑셀 json으로 변환
        const allData = XLSX.utils.sheet_to_json(worksheet, {header : 0})
        // 실패 목록 출력
        let failList = vm.data.failIndexList.map((item)=> item+5)
        const rowsToExclude = [1, 2, 3, ...failList]
        const filteredData = allData.filter((row, rowIndex) => rowsToExclude.includes(rowIndex+1))
        // json 파일 엑셀로 변환
        const newWorkSheet = XLSX.utils.json_to_sheet(filteredData)
        const newWorkbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(newWorkbook, newWorkSheet, '발송 양식')

        // 엑셀 다운로드
        const blob = XLSX.write(newWorkbook, {bookType: 'xlsx', type: 'binary'})
        FileSaver.saveAs(new Blob([s2ab(blob)], { type: 'application/octet-stream' }), `발송관리_업로드_실패_데이터.xlsx`)

        function s2ab(s) {
          const buf = new ArrayBuffer(s.length)
          const view = new Uint8Array(buf)
          for (let i = 0; i < s.length; i++) {
            view[i] = s.charCodeAt(i) & 0xFF
          }
         return buf
        }
        app.$Progress.minus()
      })
    },
    getSheetName () {
      const vm = this
      if (vm.sendScn === '01') {
        return '발송(등기) 양식'
      } else if (vm.sendScn === '02') {
        return '발송(국내택배) 양식'
      } else if (vm.sendScn === '03') {
        return '발송(해외특송) 양식'
      }
    },
    onClickClose (e) {
      const vm = this
      if (EtnersCommonUtil.isNotEmpty(vm.data) && vm.data.uploadSuccessCnt > 0) {
        // 업로드 성공한 데이터가 있을 때, 목록 데이터 새로고침
        vm.$emit('onChange');
      }
      vm.$refs.kendoWindowRef.kendoWidget().close()
    },
  },
  data () {
    const kendoGridHeaderAttributes = {
      style: 'text-align : center;'
    }
    return {
      errorListColumns: [
        {
          field: 'rowNumber',
          title: 'No.',
          width: '10%',
          sortable: false
        },
        {
          field: 'line',
          title: '행 번호',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'reason',
          title: '오류',
          width: '',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        }
      ]
    }
  }
}
</script>
